import CloseController from "../../controllers/CloseController";
import { QuestItem } from "./QuestItem";
import QuestItemController from "../../controllers/quest/QuestItemController";
import QuestDailyController from "../../controllers/quest/QuestDailyController";
import { COMPONENTS } from "../../lib/constants";
import MainGridController from "../../controllers/grid/MainGridController";
import { QuestPageMobileGrid } from "./QuestPageMobileGrid";
import { DailyQuestMobile } from "./DailyQuestMobile";
import UiConstants from "../../lib/UIconstants";

export const QuestPageMobile = {
  name: COMPONENTS.QUEST_PAGE,
  child: true,
  zIndex: 2,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: CloseController,
      name: "CloseController",
      config: {
        closeBtn: "close",
        remove: true,
      },
    },
    {
      Controller: QuestDailyController,
      name: "QuestDailyController",
      config: {
        item: "quest_daily",
        val: "quest_daily",
        btns: [UiConstants.FTR_QUEST_GO, "daily_btn"],
      },
    },
    {
      Controller: QuestItemController,
      name: "QuestItemController",
      config: {
        item: "quest_1",
        val: "quest_1",
        name: "General",
        texts: [
          "QUEST_ITEM_HEADER_1",
          "QUEST_ITEM_SUBTITLE_1",
          "QUEST_ITEM_DESC_1",
        ],
        img: "quest_major_1",
        color: "#71B2EE",

        id: 1,
      },
    },
    {
      Controller: QuestItemController,
      name: "QuestItemController",
      config: {
        item: "quest_2",
        val: "quest_2",
        name: "Scatter",
        texts: [
          "QUEST_ITEM_HEADER_2",
          "QUEST_ITEM_SUBTITLE_2",
          "QUEST_ITEM_DESC_2",
        ],
        img: "quest_scatter",
        color: "#B7EE71",
        // total: GameConfigs.quest.quest_2.total,
        // completed: GameConfigs.quest.quest_2.completed,
        id: 2,
      },
    },
    {
      Controller: QuestItemController,
      name: "QuestItemController",
      config: {
        item: "quest_3",
        val: "quest_3",
        name: "Star",
        texts: [
          "QUEST_ITEM_HEADER_3",
          "QUEST_ITEM_SUBTITLE_3",
          "QUEST_ITEM_DESC_3",
        ],
        img: "quest_star",
        color: "#B771EE",
        id: 3,
      },
    },
    {
      Controller: QuestItemController,
      name: "QuestItemController",
      config: {
        item: "quest_4",
        val: "quest_4",
        name: "Coin",
        texts: [
          "QUEST_ITEM_HEADER_4",
          "QUEST_ITEM_SUBTITLE_4",
          "QUEST_ITEM_DESC_4",
        ],
        img: "quest_coin",
        color: "#EE71AD",
        id: 4,
      },
    },
    {
      Controller: MainGridController,
      name: "QuestPageGrid",
      config: QuestPageMobileGrid,
    },
  ],
  components: [
    {
      name: "quest_page_main_bg",
      type: "Sprite",
      img: "reel_bg",
    },
    {
      name: "header",
      type: "CustomText",
      text: "QUEST_DAILY_HEADER",
    },
    {
      name: "close",
      type: "Button",
      components: [
        {
          name: "bg",
          type: "MouseOverSprite",
          img: "close_icon",
          imgHover: "close_icon_hovered",
		  position: {
            x: 0,
            y: -10,
          },
        },
      ],
    },
    {
      name: "quest_daily",
      position: { x: 0, y: 0 },
      type: "VisualComponent",
      component: DailyQuestMobile,
    },
    {
      name: "quest_1",
      position: { x: 0, y: 0 },
      type: "VisualComponent",
      component: QuestItem,
    },
    {
      name: "quest_2",
      position: { x: 0, y: 0 },
      type: "VisualComponent",
      component: QuestItem,
    },
    {
      name: "quest_3",
      position: { x: 0, y: 0 },
      type: "VisualComponent",
      component: QuestItem,
    },
    {
      name: "quest_4",
      position: { x: 0, y: 0 },
      type: "VisualComponent",
      component: QuestItem,
    },
    // {
    //   name: "quest_claim_btn",
    //   type: "Sprite",
    //   components: [
    //     {
    //       name: UiConstants.FTR_QUEST_GO,
    //       type: "ActionButton",
    //       position: { x: 105, y: 50 },
    //       bg: "go_btn",
    //     },
    //     {
    //       name: "daily_btn",
    //       type: "SwitchButton",
    //       position: { x: 105, y: 50 },
    //       bg: "claim_btn_lowered",
    //       fg: "claimed_btn",
    //     },
    //   ],
    // },
  ],
};
